import React from 'react';
import { defineMessages, useIntl } from 'react-intl';
import { TypedMemo } from '../../common/types';
import { PlanHighlight } from './planHighlights';
import { PlanHighlightItems } from './PlanHighlightItems';
import { scrollToPlansCompare } from './scrollToPlansCompare';
/* eslint-disable css-modules/no-unused-class -- one stylesheet for the plan highlights; each part uses its own slice of it */
import styles from './PlanHighlightList.module.scss';
/* eslint-enable css-modules/no-unused-class */

/** A card shows this many lines; the rest are in the compare table. */
export const PLAN_CARD_HIGHLIGHTS = 5;

export const planHighlightMessages = defineMessages({
  more: {
    id: 'app.sml.plans.card.more',
    defaultMessage: '+ {count, plural, one {# more} other {# more}} in the table',
  },
  seeAll: { id: 'app.sml.plans.card.seeAll', defaultMessage: 'See every limit' },
});

interface PlanHighlightListProps {
  /** "Everything in Plus, plus". */
  lead: string;
  highlights: PlanHighlight[];
  className?: string;
}

/** The lines of a paid plan card (design plans-page a): a lead, ticks, and a link to the compare table. */
const PlanHighlightListComponent: React.FC<PlanHighlightListProps> = ({ lead, highlights, className }) => {
  const intl = useIntl();
  const shown = highlights.slice(0, PLAN_CARD_HIGHLIGHTS);
  const hidden = highlights.length - shown.length;

  return (
    <div className={className}>
      <div className={styles.lead}>{lead}</div>
      <PlanHighlightItems highlights={shown} />
      <button type="button" className={styles.more} onClick={scrollToPlansCompare}>
        {hidden > 0
          ? intl.formatMessage(planHighlightMessages.more, { count: hidden })
          : intl.formatMessage(planHighlightMessages.seeAll)}
      </button>
    </div>
  );
};

export const PlanHighlightList = TypedMemo(PlanHighlightListComponent);
